import React, { useContext } from 'react';
import c from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import BasicUserLink from '../_partials/BasicUserLink/BasicUserLink';
import BasicUserName from '../BasicUserName';
import s from './UserLink.scss';
export const UserLink = ({ user, showSymbol, symbolClassName, useCoreRibbon, coreRibbonClassname, usernameClassName, linkTo, className, biData, children, tabIndex, 'data-hook': dataHook })=>{
    const isMobile = useContext(MobileContext);
    // in some cases this could be null, example deviation.author
    if (!user) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "UserLink"
    }, /*#__PURE__*/ React.createElement(BasicUserLink, {
        user: user,
        linkTo: linkTo,
        className: c(className, useCoreRibbon && s['with-svg-core-badge']),
        biData: biData,
        tabIndex: tabIndex,
        "data-hook": dataHook
    }, children ? children : /*#__PURE__*/ React.createElement(BasicUserName, {
        user: user,
        showSymbol: showSymbol,
        symbolOpensPopup: !isMobile,
        symbolClassName: symbolClassName,
        useCoreRibbon: useCoreRibbon,
        coreRibbonClassname: coreRibbonClassname,
        usernameClassName: usernameClassName
    })));
};
UserLink.displayName = 'UserLink';
export default UserLink;
